import React, { ReactElement, useEffect } from 'react';
import { useDataCollection } from '../../../../hooks';
import { InjectedWizardStepProps } from '../../../components/Steps/WizardStep';
import StepHeader from '../../../components/Layout/StepHeader';
import { floorInsulationOptions } from '../../../../data/enumerations';
import { WizardStep } from '../../../../types';
import CheckCard from '../../../components/Form/CheckCard';
import { Form } from 'formik';

const StepFloorInsulation = ({ completeStep, setNextStepId }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, values } = useDataCollection();

    useEffect(() => {
        if (values.floorInsulation) {
            const nextStepId =
                values.floorInsulation === 'NONE' ? WizardStep.RoofInsulation : WizardStep.FloorInsulationThickness;
            setNextStepId && setNextStepId(nextStepId);
            completeStep && completeStep(true);
        }
    }, [values, completeStep]);

    return (
        <Form>
            <StepHeader title="Zateplení podlahy" />
            <div className={'wiz-card wiz-card--small'}>
                <div className={'wiz-card__inner'}>
                    {floorInsulationOptions.map(({ value, title, description, img }) => {
                        return (
                            <div key={value} className={'wiz-card-item'}>
                                <CheckCard
                                    name={'floorInsulation'}
                                    onChange={handleChange}
                                    checked={values.floorInsulation === value}
                                    value={value}
                                    img={img}
                                    bigImg={true}
                                    title={title}
                                    description={description}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </Form>
    );
};

export default StepFloorInsulation;
